import { IApplicationState } from '../../types/redux';
import { getActiveTagFilters } from './getActiveTagFilters';

export function getActiveTagFiltersValue(state: IApplicationState) {
  const tag = getActiveTagFilters(state);

  return tag?.type;
}
